export enum ApplicationStatusCode {
  new = 1,
  inProgress = 2,
  completed = 3,
  pendingPaymentPlanApproval = 4,
  approved = 5,
  rejected = 6,
  canceled = 7,
  error = 8,
  pendingManagerApproval = 9,
  archived = 10,
  screening = 11,
  pendingScreeningManualApproval = 12,
  reopened = 13
}

export enum ProductTypeCode {
  sda = 1,
  fsd = 2,
  sds = 3,
  sdi = 4,
  umbrellaSda = 5,
  umbrellaSdi = 6
}
